import React, { useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import './Sidebar.css';
import DashboardIcon from '@mui/icons-material/Dashboard';
import PersonIcon from '@mui/icons-material/Person';
import WorkIcon from '@mui/icons-material/Work';
import ListAltIcon from '@mui/icons-material/ListAlt';
import ConfirmationNumberIcon from '@mui/icons-material/ConfirmationNumber';
import LibraryBooksIcon from '@mui/icons-material/LibraryBooks';
import CampaignIcon from '@mui/icons-material/Campaign';
import ReportsIcon from '@mui/icons-material/Timeline';
import MenuOpenIcon from '@mui/icons-material/MenuOpen';
import AssignmentIcon from '@mui/icons-material/Assignment';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import MenuIcon from '@mui/icons-material/Menu';
import SmartToyIcon from '@mui/icons-material/SmartToy';


const Sidebar = ({ isCollapsed, toggleSidebar }) => {
	const location = useLocation();
	const [openSubmenu, setOpenSubmenu] = useState(null);

	const menuItems = [
		{
			path: "/",
			icon: <DashboardIcon />,
			linkText: "My Dashboard",
		},
		{
			path: "/user_management",
			icon: <PersonIcon />,
			linkText: "User Management",
		},
		{
			path: "/source_business",
			icon: <WorkIcon />,
			linkText: "Brand Management",
		},
		{
			path: "/offerings",
			icon: <ListAltIcon />,
			linkText: "Offerings",
		},
		{
			path: "/vouchers",
			icon: <ConfirmationNumberIcon />,
			linkText: "Vouchers",
		},
		{
			path: "/collections",
			icon: <LibraryBooksIcon />,
			linkText: "Collections",
		},
		{
			path: "/campaigns",
			icon: <CampaignIcon />,
			linkText: "Campaigns",
		},
		{
			
			path: "/chatbot-management",
			icon: <SmartToyIcon />,
			linkText: "Chatbot Management",
		},
		{
			path: "/platform-report",
			icon: <MenuOpenIcon />,
			linkText: "Platform Report",
			subItems: [
				{ path: "/platform-report/user", linkText: "User", icon: <ReportsIcon /> },
				{ path: "/platform-report/brand", linkText: "Brand", icon: <AssignmentIcon /> },
			]
		},
	];

	

	const handleToggleSubmenu = (index) => {
		setOpenSubmenu(openSubmenu === index ? null : index);
	};

	const isActive = (path) => {
		return location.pathname === path;
	};

	const hasActiveSubItem = (item) => {
		if (!item.subItems) return false;
		return item.subItems.some((subItem) => isActive(subItem.path));
	};

	return (
		<div className={`sidebar ${isCollapsed ? 'collapsed' : ''}`}>
			<div className="sidebar-brand-row">
				<button
					type="button"
					className="sidebar-toggle-btn"
					onClick={toggleSidebar}
					aria-label={isCollapsed ? "Expand sidebar" : "Collapse sidebar"}
				>
					<MenuIcon />
				</button>
				{!isCollapsed && (
					<div className="sidebar-logo-wrap">
						<img
							src="https://cdn-be.plutos.one/images/cbms/campaign/image-1749729864850-image-1717136552249-image-1716968400113-Frame 2609485.svg"
							alt="Plutos ONE Logo"
							className="sidebar-logo"
						/>
					</div>
				)}
			</div>
			<div className="sidebar-nav">
				{menuItems.map((item, index) => (
				<div key={index} className='sidebar-item-container'>
					{item.subItems ? (
						<button
							type="button"
							className={`${!isCollapsed ? "sidebar-item sidebar-item-two" : 'sidebar-item'} ${openSubmenu === index ? 'active' : ''} ${hasActiveSubItem(item) ? 'parent-active' : ''}`}
							onClick={() => handleToggleSubmenu(index)}
						>
							{item.icon}
							{!isCollapsed && <span >{item.linkText}</span>}
							{!isCollapsed && (
								openSubmenu === index ? <ExpandLessIcon fontSize="small" /> : <ExpandMoreIcon fontSize="small" />
							)}
						</button>
					) : (
						<NavLink
							to={item.path}
							className={({ isActive: navIsActive }) =>
								`sidebar-item ${navIsActive ? 'active' : ''}`
							}
						>
							{item.icon}
							{!isCollapsed && <span>{item.linkText}</span>}
						</NavLink>
					)}

					{/* Submenu rendering */}
					{item.subItems && openSubmenu === index && (
						<div className="submenu">
							{item.subItems.map((subItem, subIndex) => (
								<NavLink
									key={subIndex}
									to={subItem.path}
									className={({ isActive: navIsActive }) =>
										`sidebar-item sub-item ${navIsActive ? 'active' : ''}`
									}
								>
									{subItem.icon}
									{!isCollapsed && <span>{subItem.linkText}</span>}
								</NavLink>
							))}
						</div>
					)}
				</div>
			))}
			</div>
		</div>
	);
};

export default Sidebar;
